// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaClipboardList, FaRegFileAlt, FaTrophy, FaWpforms } from 'react-icons/fa';
// import H1 from '../Images/Hma.jpeg';
// import L1 from '../Images/logo-w.png';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Dashboard = () => {
//     return (
//         <div className="mt-1 d-flex flex-column" style={{ minHeight: '100vh' }}>

//             <img src={H1} alt="item" className="img-fluid w-100" style={{ height: 'clamp(100px, 25vw, 150px)', objectFit: 'cover', }} />

//             <div className="container mt-5">
//                 <div className="row g-3 justify-content-center">
//                     <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
//                         <Link to="/session-topic" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
//                             <FaClipboardList style={{ fontSize: '20px' }} />
//                             <span>Session Topic</span>
//                         </Link>
//                     </div>

//                     <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
//                         <Link to="/feedback-form" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
//                             <FaRegFileAlt style={{ fontSize: '20px' }} />
//                             <span>Feedback Form</span>
//                         </Link>
//                     </div>

//                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
//                         <Link to="/formdashboard" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
//                             <FaRegFileAlt style={{ fontSize: '20px' }} />
//                             <span>Forms</span>
//                         </Link>
//                     </div>

//                     {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
//                         <Link to="/" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }} >
//                             <FaWpforms style={{ fontSize: '20px' }} />
//                             <span>Awards</span>
//                         </Link>
//                     </div>
//                     <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
//                         <Link to="/awards-nomination" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
//                             <FaTrophy style={{ fontSize: '20px' }} />
//                             <span>Awards Nomination Data</span>
//                         </Link>
//                     </div> */}

//                 </div>
//             </div>

//             <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto', }}>
//                 <div>
//                     <p style={{ margin: '0', fontSize: '14px' }}>Powered by<a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>EMedha Technologies</a></p>
//                     <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer"><img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} /></a>
//                 </div>
//             </footer>
//         </div>
//     );
// };

// export default Dashboard;













import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    FaClipboardList,
    FaRegFileAlt,
    FaSignOutAlt,
    FaChevronDown
} from 'react-icons/fa';

import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dashboard = () => {
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    };

    const menuItems = [
        {
            title: 'Session Topic',
            icon: <FaClipboardList />,
            path: '/session-topic',
            color: '#2563eb'
        },
        {
            title: 'Feedback Form',
            icon: <FaRegFileAlt />,
            path: '/feedback-form',
            color: '#7c3aed'
        },
        {
            title: 'Forms',
            icon: <FaRegFileAlt />,
            path: '/formdashboard',
            color: '#059669'
        }
    ];

    return (
        <div className="dashboard-page">

            {/* ================= HEADER ================= */}
            <header className="dashboard-header">
                <div className="header-inner">

                    <div className="brand">
                        <div className="brand-icon">E</div>
                        <div className="brand-text">
                            <h5>EMedha</h5>
                            <span>Dashboard</span>
                        </div>
                    </div>

                    <div className="logout-wrapper">
                        <button type="button" className={`logout-icon ${showLogout ? 'active' : ''}`} onClick={() => setShowLogout(!showLogout)} aria-label="Account menu">
                            <FaSignOutAlt />
                            <FaChevronDown className="logout-arrow" />
                        </button>

                        {showLogout && (
                            <div className="logout-menu">
                                <div className="logout-title">Account</div>
                                <button type="button" className="logout-button" onClick={handleLogout}><FaSignOutAlt /><span>Logout</span></button>
                            </div>
                        )}
                    </div>

                </div>
            </header>

            {/* ================= HERO ================= */}
            <section className="hero-section">
                <img src={H1} alt="EMedha" className="hero-image" />

                <div className="hero-overlay">
                    <div className="hero-content">
                        <span className="hero-label"> Welcome </span>
                        <h1>Dashboard</h1>
                        <p>Select an option below to continue</p>
                    </div>
                </div>
            </section>

            {/* ================= CONTENT ================= */}
            <main className="dashboard-content">

                <div className="container">

                    <div className="section-heading">
                        <h2>Quick Access</h2>
                        <p>Choose a service to get started</p>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {menuItems.map((item, index) => (
                            <div className="col-12 col-sm-6 col-lg-4" key={index}>
                                <Link to={item.path} className="dashboard-card">
                                    <div className="card-icon" style={{ backgroundColor: `${item.color}15`, color: item.color }}>{item.icon}</div>
                                    <div className="card-content">
                                        <h3>{item.title}</h3>
                                        <p>Open {item.title.toLowerCase()}</p>
                                    </div>
                                    <div className="card-arrow" style={{ color: item.color }}>→</div>
                                </Link>
                            </div>
                        ))}

                    </div>
                </div>

            </main>

            {/* ================= FOOTER ================= */}
            <footer className="dashboard-footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-brand">
                            <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                                <img src={L1} alt="EMedha Technologies" />
                            </a>
                        </div>

                        <div className="footer-text">
                            <p>Powered by{' '}
                                <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">EMedha Technologies</a>
                            </p>

                            <span>
                                © {new Date().getFullYear()} EMedha Technologies.
                                All rights reserved.
                            </span>
                        </div>

                    </div>

                </div>

            </footer>

            {/* ================= STYLES ================= */}
            <style>{`

                * {
                    box-sizing: border-box;
                }

                .dashboard-page {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    background: #f8fafc;
                    color: #1e293b;
                }

                /* HEADER */

                .dashboard-header {
                    position: sticky;
                    top: 0;
                    z-index: 1000;
                    background: rgba(255, 255, 255, 0.96);
                    backdrop-filter: blur(12px);
                    border-bottom: 1px solid #e2e8f0;
                }

                .header-inner {
                    width: 100%;
                    max-width: 1200px;
                    margin: auto;
                    padding: 12px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .brand {
                    display: flex;
                    align-items: center;
                    gap: 11px;
                }

                .brand-icon {
                    width: 42px;
                    height: 42px;
                    border-radius: 12px;
                    background: linear-gradient(
                        135deg,
                        #2563eb,
                        #4f46e5
                    );
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 21px;
                    font-weight: 700;
                    box-shadow: 0 5px 15px rgba(37, 99, 235, 0.2);
                }

                .brand-text h5 {
                    margin: 0;
                    font-size: 17px;
                    font-weight: 700;
                    color: #0f172a;
                }

                .brand-text span {
                    font-size: 12px;
                    color: #64748b;
                }

                /* LOGOUT */

                .logout-wrapper {
                    position: relative;
                }

                .logout-icon {
                    height: 42px;
                    min-width: 42px;
                    padding: 0 10px;
                    border: 1px solid #e2e8f0;
                    border-radius: 11px;
                    background: white;
                    color: #475569;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .logout-icon:hover,
                .logout-icon.active {
                    background: #eff6ff;
                    color: #2563eb;
                    border-color: #bfdbfe;
                }

                .logout-arrow {
                    font-size: 9px;
                }

                .logout-menu {
                    position: absolute;
                    right: 0;
                    top: 52px;
                    width: 170px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 8px;
                    box-shadow:
                        0 10px 30px rgba(15, 23, 42, 0.12),
                        0 2px 8px rgba(15, 23, 42, 0.05);
                    animation: menuOpen 0.15s ease-out;
                }

                @keyframes menuOpen {
                    from {
                        opacity: 0;
                        transform: translateY(-5px);
                    }

                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .logout-title {
                    padding: 7px 10px;
                    color: #94a3b8;
                    font-size: 11px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .logout-button {
                    width: 100%;
                    border: none;
                    background: transparent;
                    border-radius: 8px;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    color: #dc2626;
                    font-size: 14px;
                    cursor: pointer;
                    text-align: left;
                    transition: 0.2s;
                }

                .logout-button:hover {
                    background: #fef2f2;
                }

                /* HERO */

                .hero-section {
                    position: relative;
                    height: clamp(180px, 28vw, 280px);
                    overflow: hidden;
                }

                .hero-image {
                    width: 100%;
                    height: 100%;
                    object-fit: fit;
                    display: block;
                }

                .hero-overlay {
                    position: absolute;
                    inset: 0;
                    background:
                        linear-gradient(
                            90deg,
                            rgba(15, 23, 42, 0.72),
                            rgba(15, 23, 42, 0.25),
                            rgba(15, 23, 42, 0.05)
                        );
                    display: flex;
                    align-items: center;
                }

                .hero-content {
                    width: 100%;
                    max-width: 1200px;
                    margin: auto;
                    padding: 25px;
                    color: white;
                }

                .hero-label {
                    display: inline-block;
                    padding: 5px 11px;
                    border-radius: 20px;
                    background: rgba(255,255,255,0.18);
                    backdrop-filter: blur(5px);
                    font-size: 12px;
                    margin-bottom: 8px;
                }

                .hero-content h1 {
                    margin: 0;
                    font-size: clamp(28px, 5vw, 44px);
                    font-weight: 700;
                }

                .hero-content p {
                    margin: 6px 0 0;
                    font-size: clamp(13px, 2vw, 16px);
                    color: rgba(255,255,255,0.85);
                }

                /* CONTENT */

                .dashboard-content {
                    flex: 1;
                    padding: 45px 0 55px;
                }

                .section-heading {
                    text-align: center;
                    margin-bottom: 30px;
                }

                .section-heading h2 {
                    margin: 0;
                    font-size: 25px;
                    font-weight: 700;
                    color: #0f172a;
                }

                .section-heading p {
                    margin: 6px 0 0;
                    color: #64748b;
                    font-size: 14px;
                }

                /* CARDS */

                .dashboard-card {
                    height: 100%;
                    min-height: 125px;
                    padding: 22px;
                    border-radius: 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    text-decoration: none;
                    color: inherit;
                    box-shadow: 0 3px 12px rgba(15, 23, 42, 0.04);
                    transition:
                        transform 0.2s ease,
                        box-shadow 0.2s ease,
                        border-color 0.2s ease;
                }

                .dashboard-card:hover {
                    transform: translateY(-4px);
                    border-color: #bfdbfe;
                    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.09);
                    color: inherit;
                }

                .card-icon {
                    flex-shrink: 0;
                    width: 55px;
                    height: 55px;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 23px;
                }

                .card-content {
                    flex: 1;
                    min-width: 0;
                }

                .card-content h3 {
                    margin: 0 0 5px;
                    font-size: 17px;
                    font-weight: 650;
                    color: #0f172a;
                }

                .card-content p {
                    margin: 0;
                    font-size: 13px;
                    color: #64748b;
                }

                .card-arrow {
                    font-size: 22px;
                    transition: transform 0.2s ease;
                }

                .dashboard-card:hover .card-arrow {
                    transform: translateX(4px);
                }

                /* FOOTER */

                .dashboard-footer {
                    background: white;
                    border-top: 1px solid #e2e8f0;
                    padding: 20px 0;
                }

                .footer-content {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 18px;
                    text-align: left;
                }

                .footer-brand img {
                    width: 145px;
                    max-width: 100%;
                    height: auto;
                }

                .footer-text p {
                    margin: 0 0 3px;
                    color: #64748b;
                    font-size: 13px;
                }

                .footer-text p a {
                    color: #2563eb;
                    text-decoration: none;
                    font-weight: 600;
                }

                .footer-text span {
                    color: #94a3b8;
                    font-size: 11px;
                }

                /* TABLET */

                @media (max-width: 768px) {

                    .header-inner {
                        padding: 10px 16px;
                    }

                    .hero-section {
                        height: 220px;
                    }

                    .hero-content {
                        padding: 20px;
                    }

                    .dashboard-content {
                        padding: 35px 0 45px;
                    }

                    .section-heading {
                        margin-bottom: 22px;
                    }

                    .dashboard-card {
                        min-height: 110px;
                    }
                }

                /* MOBILE */

                @media (max-width: 576px) {

                    .brand-icon {
                        width: 38px;
                        height: 38px;
                        border-radius: 10px;
                    }

                    .brand-text h5 {
                        font-size: 15px;
                    }

                    .brand-text span {
                        font-size: 11px;
                    }

                    .logout-icon {
                        height: 38px;
                        min-width: 38px;
                    }

                    .hero-section {
                        height: 190px;
                    }

                    .hero-overlay {
                        background:
                            linear-gradient(
                                90deg,
                                rgba(15, 23, 42, 0.7),
                                rgba(15, 23, 42, 0.2)
                            );
                    }

                    .hero-content {
                        padding: 18px;
                    }

                    .hero-content h1 {
                        font-size: 30px;
                    }

                    .hero-content p {
                        font-size: 13px;
                    }

                    .dashboard-content {
                        padding: 30px 12px 40px;
                    }

                    .section-heading h2 {
                        font-size: 22px;
                    }

                    .dashboard-card {
                        min-height: 100px;
                        padding: 17px;
                        border-radius: 14px;
                    }

                    .card-icon {
                        width: 48px;
                        height: 48px;
                        border-radius: 12px;
                        font-size: 20px;
                    }

                    .card-content h3 {
                        font-size: 15px;
                    }

                    .card-content p {
                        font-size: 12px;
                    }

                    .card-arrow {
                        font-size: 19px;
                    }

                    .footer-content {
                        flex-direction: column;
                        gap: 8px;
                        text-align: center;
                    }

                    .footer-brand img {
                        width: 130px;
                    }

                    .logout-menu {
                        right: -2px;
                    }
                }

            `}</style>
        </div>
    );
};

export default Dashboard;
